export const TerminationActionTypes = {
    API_RESPONSE_SUCCESS: '@@termination/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@termination/API_RESPONSE_ERROR',
    GET_TERMINATION: '@@termination/GET_TERMINATION',
    SUBMIT_TERMINATION: '@@termination/SUBMIT_TERMINATION',
    CONFIRM_TERMINATION: '@@termination/CONFIRM_TERMINATION',
    RETRACT_TERMINATION: '@@termination/RETRACT_TERMINATION',
    RESET_TERMINATION: '@@termination/RESET_TERMINATION',
};
